export const businessMocks = [
  {
    businessName: "구독 시스템",
    businessThumb: "https://www.lg.co.kr/media/release/images/41811",
    businessAlt: "subscribe",
  },
  {
    businessName: "야구장 예약",
    businessThumb:
      "https://blog.kakaocdn.net/dn/bNRfEH/btsGsiELINI/FGzBs8wR6dC6bxD7CwuEv1/img.png",
    businessAlt: "baseball_reservation",
  },
  {
    businessName: "구독자 쇼핑 시스템",
    businessThumb:
      "https://www.foodnews.news/data/photos/20220207/art_16448993720428_521f60.jpg",
    businessAlt: "subscribe_shopping",
  },
  {
    businessName: "야구장 음식 이벤트",
    businessThumb:
      "https://img1.newsis.com/2023/07/26/NISI20230726_0001325049_web.jpg",
    businessAlt: "baseball_food",
  },
  {
    businessName: "야구장 응원 이벤트",
    businessThumb:
      "https://lh5.googleusercontent.com/proxy/sDECIyoL4cQhkl4c7CoKMUsiwJ5SEvPIcwOlnpPMoMfeOSGDfbaPEoxwMwJaAJhryN11KrP7s8_woei43QiycoKPbOPCibUuTPkNu9o6LvNXPR3pUMzQZGSnZtzT7pQhNV4TNn_mhDeixmlSB098yySmQ-HNpXsFKN_zT1-NjjXdV1NrttedRZ7-foFLFCAIb2LMoyWX0OPR8AbiuHlDmkK983RJWPNRAB91dOpPYSTSmgy0dZPDXR-bNHboYCSpdElNlUXT5ky1pP-uIVjop96DNSTBhAAKu2GGtJPaSws",
    businessAlt: "baseball_fighting",
  },
];
